import Group from './Group.i18n';

export default Group